import React, {useContext} from "react";

const defaultValue = {
    title: '',
    component: (<div></div>),
    open: false,
    style: {},
    modal2: {
        open: false,
        component: null,
        title: ''
    }
}

export const ModalActions = {
    OPEN_MODAL: 'OPEN_MODAL',
    CLOSE_MODAL: 'CLOSE_MODAL',
}

const ModalContext = React.createContext(defaultValue)

function modalReducer(state, action)
{
    switch (action.type)
    {
        case ModalActions.OPEN_MODAL: {
            if(state.open)
            {
                return {
                    ...state,
                    modal2: {
                        open: true,
                        component: action.component,
                        title: action.title
                    }
                }
            }

            return {
                ...state,
                open: true,
                component: action.component,
                title: action.title,
                style: action.style
            }
        }
        case ModalActions.CLOSE_MODAL: {
            if(state.modal2.open)
            {
                return {
                    ...state,
                    modal2: defaultValue.modal2
                }
            }
            return defaultValue
        }
        default: {
            return defaultValue
        }
    }
}

function ModalProvider({children})
{
    const [modal, dispatch] = React.useReducer(modalReducer, defaultValue);

    const value = {modal, dispatch};

    return (
        <ModalContext.Provider value={value}>
            {children}
        </ModalContext.Provider>
    )
}

function useModal()
{
    const context = React.useContext(ModalContext);

    if(!context)
        throw new Error('Modal Provider Error')

    const {modal, dispatch} = context;

    const openModal = ({title, component, style}) => {
        dispatch({
            type: ModalActions.OPEN_MODAL,
            component: component,
            title: title,
            style: style
        })
    }

    const closeModal = () => {
        dispatch({
            type: ModalActions.CLOSE_MODAL,
        })
    }

    return {
        modal: modal,
        openModal,
        closeModal
    }
}

export {ModalProvider, useModal}
